// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__w5w_t","closeIcon":"styles_closeIcon__2gK1D","text":"styles_text__1f_ug"};